import React, { useState } from "react";
import "./Register.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa";
import { Link ,useNavigate } from "react-router-dom";
import bgImage from "../../assets/images/Whygrene background.svg"; 
import {ToastContainer, toast} from 'react-toastify';
import { useMsal } from "@azure/msal-react";
import { msalConfig, silentRequest } from "../../msalconfig";
import { encryptPassword } from "../../encryption";
import { PYTHON_API_BASE_URL } from "../../services/api/apiConstants";
import { useNavigation } from "../../contexts/NavigationContext";

export default function RegisterForm() {
  const { instance } = useMsal();
  const { setSelectedBranch } = useNavigation();
  const [errors, setErrors] = useState({});
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showBranchPopup, setShowBranchPopup] = useState(false);
  const [isLoadingBranch, setIsLoadingBranch] = useState(false);
  const currentStep = "organization";
  const [branchFormData, setBranchFormData] = useState({
    branchName: "",
    addressLine: "",
    city: "",
    state: "",
    country: "US",
    zipCode: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });
  const [branchErrors, setBranchErrors] = useState({});
  const placeholders = {
    US: "Ex. 231 221 1299",
    IN: "Ex. 98765 43210",
    UK: "Ex. 07123 456789",
  };

  const normalizeDomainInput = (value = "") => {
    if (!value) return "";
    let cleanedValue = value.trim();
    cleanedValue = cleanedValue.replace(/^https?:\/\//i, "");
    cleanedValue = cleanedValue.replace(/^www\./i, "");
    cleanedValue = cleanedValue.split("/")[0];
    cleanedValue = cleanedValue.replace(/:\d+$/, "");
    return cleanedValue;
  };

const ORG_SIGNUP_FIELD_MAP = {
  organization_name: "organizationName",
  domain_name: "domain",
  address_line: "addressLine",
  city: "city",
  state: "state",
  country: "country",
  zip_code: "zipCode",
  org_admin_email: "email",
  org_admin_first_name: "firstName",
  org_admin_last_name: "lastName",
  org_admin_phone: "phone",
  password: "password",
};

const collectApiErrors = (payload, fieldMap = {}) => {
  const messages = [];
  const fieldErrors = {};

  const pushMessage = (value) => {
    if (typeof value === "string" && value.trim()) {
      messages.push(value.trim());
    }
  };

  const assignFieldErrors = (source) => {
    if (!source || typeof source !== "object" || Array.isArray(source)) {
      return;
    }

    Object.entries(source).forEach(([key, value]) => {
      const mappedField = fieldMap[key];

      if (Array.isArray(value)) {
        const joinedValue = value
          .filter((item) => typeof item === "string" && item.trim())
          .join(" ");

        if (mappedField && joinedValue) {
          fieldErrors[mappedField] = joinedValue;
        }

        value.forEach(pushMessage);
        return;
      }

      if (typeof value === "string") {
        if (mappedField) {
          fieldErrors[mappedField] = value.trim();
        }
        pushMessage(value);
      }
    });
  };

  assignFieldErrors(payload);

  if (payload?.error) {
    if (typeof payload.error === "string") {
      pushMessage(payload.error);
    } else if (typeof payload.error === "object") {
      pushMessage(payload.error.message);
      assignFieldErrors(payload.error.details);

      if (payload.error.details && typeof payload.error.details === "object") {
        Object.values(payload.error.details).forEach((value) => {
          if (Array.isArray(value)) {
            value.forEach(pushMessage);
          } else {
            pushMessage(value);
          }
        });
      }
    }
  }

  return {
    fieldErrors,
    messages: [...new Set(messages)],
  };
};

  const generateDefaultBranchName = (orgName = "") => {
    const trimmedName = (orgName || "").trim();
    console.log("[generateDefaultBranchName] Organization Name:", trimmedName);
    if (!trimmedName) {
      throw new Error("Organization name is required to generate a branch name");
    }
    const branchName = `${trimmedName} (Default)`;
    console.log("[generateDefaultBranchName] Branch Name:", branchName);
    return branchName;
  };

  const buildDefaultBranchPayload = (orgValues, organizationId, resourceGroupName) => {
    const defaultBranchName = generateDefaultBranchName(orgValues.organizationName);

    return {
      branch_name: defaultBranchName,
      address_line: orgValues.addressLine,
      city: orgValues.city,
      state: orgValues.state,
      country: orgValues.country,
      zip_code: orgValues.zipCode,
      branch_admin_first_name: orgValues.firstName,
      branch_admin_last_name: orgValues.lastName,
      branch_admin_email: orgValues.email,
      branch_admin_phone: orgValues.phone,
      password: encryptPassword(orgValues.password), // orgValues.password,
      org_id: organizationId,
      resource_group_name: resourceGroupName,
    };
  };

  const createBranchRequest = async (payload, token) => {
    const response = await fetch(
      `${PYTHON_API_BASE_URL}/branch-creation-signUp/`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "X-User-ID": sessionStorage.getItem("UserID") || "",
        },
        body: JSON.stringify(payload),
      }
    );

    const responseText = await response.text();
    let data = {};
    try {
      data = responseText ? JSON.parse(responseText) : {};
    } catch (parseError) {
      throw new Error(responseText || `Failed with status: ${response.status}`);
    }

    if (!response.ok) {
      let errorMsg = "Failed to create branch";

      if (data) {
        const errorMessages = [];
        Object.keys(data).forEach((key) => {
          if (Array.isArray(data[key]) && data[key].length > 0) {
            errorMessages.push(...data[key]);
          } else if (typeof data[key] === "string" && data[key].trim()) {
            errorMessages.push(data[key]);
          } else if (typeof data[key] === "object" && data[key] !== null) {
            const objStr = JSON.stringify(data[key]);
            if (objStr && objStr !== "{}") {
              errorMessages.push(objStr);
            }
          }
        });

        if (errorMessages.length > 0) {
          errorMsg = errorMessages.join(". ");
        } else if (data.error) {
          errorMsg = typeof data.error === "string" ? data.error : JSON.stringify(data.error);
        } else if (data.message) {
          errorMsg = typeof data.message === "string" ? data.message : JSON.stringify(data.message);
        } else if (data.detail) {
          errorMsg = typeof data.detail === "string" ? data.detail : JSON.stringify(data.detail);
        }
      } else if (responseText && responseText.trim()) {
        errorMsg = responseText;
      }

      const storageMatch = errorMsg.match(/Storage Account .* already exists/i);
      if (storageMatch) {
        errorMsg = "Storage account name already exists. Please try a different branch name.";
      } else if (errorMsg.toLowerCase().includes("branch") && errorMsg.toLowerCase().includes("already exists")) {
        errorMsg = "Branch name already exists. Please use a different branch name.";
      } else if (
        errorMsg.toLowerCase().includes("uuid") ||
        (errorMsg.toLowerCase().includes("invalid") && errorMsg.toLowerCase().includes("id"))
      ) {
        errorMsg = `Invalid organization ID or resource group. ${errorMsg}`;
      }

      throw new Error(errorMsg);
    }

    return data;
  };

  const createDefaultBranchAndNavigate = async (
    organizationId,
    resourceGroupName,
    token,
    orgValues
  ) => {
    const defaultBranchPayload = buildDefaultBranchPayload(
      orgValues,
      organizationId,
      resourceGroupName
    );
    const branchData = await createBranchRequest(defaultBranchPayload, token);

    if (branchData.id) {
      setSelectedBranch({ id: branchData.id, branch_name: branchData.branch_name, admin_email: branchData.admin_email, address: branchData.address });
    }

    sessionStorage.setItem("email", orgValues.email);
    navigate("/employeehomepage");
  };
  const [formData, setFormData] = useState({
    organizationName: "",
    domain: "",
    addressLine: "",
    city: "",
    state: "",
    country: "US",
    zipCode: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });
const [isStateDropdownOpen, setIsStateDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const usStates = [
    { name: 'Alabama', abbr: 'Alabama' },
    { name: 'Alaska', abbr: 'Alaska' },
    { name: 'Arizona', abbr: 'Arizona' },
    { name: 'Arkansas', abbr: 'Arkansas' },
    { name: 'California', abbr: 'California' },
    { name: 'Colorado', abbr: 'Colorado' },
    { name: 'Connecticut', abbr: 'Connecticut' },
    { name: 'Delaware', abbr: 'Delaware' },
    { name: 'Florida', abbr: 'Florida' },
    { name: 'Georgia', abbr: 'Georgia' },
    { name: 'Hawaii', abbr: 'Hawaii' },
    { name: 'Idaho', abbr: 'Idaa' },
    { name: 'Illinois', abbr: 'Illinois' },
    { name: 'Indiana', abbr: 'Indiana' },
    { name: 'Iowa', abbr: 'Iowa' },
    { name: 'Kansas', abbr: 'Kansas' },
    { name: 'Kentucky', abbr: 'Kentucky' },
    { name: 'Louisiana', abbr: 'Louisiana' },
    { name: 'Maine', abbr: 'Maine' },
    { name: 'Maryland', abbr: 'Maryland' },
    { name: 'Massachusetts', abbr: 'Massachusetts' },
    { name: 'Michigan', abbr: 'Michigan' },
    { name: 'Minnesota', abbr: 'Minnesota' },
    { name: 'Mississippi', abbr: 'Mississippi' },
    { name: 'Missouri', abbr: 'Missouri' },
    { name: 'Montana', abbr: 'Montana' },
    { name: 'Nebraska', abbr: 'Nebraska' },
    { name: 'Nevada', abbr: 'Nevada' },
    { name: 'New Hampshire', abbr: 'New Hampshire' },
    { name: 'New Jersey', abbr: 'New Jersey' },
    { name: 'New Mexico', abbr: 'New Mexico' },
    { name: 'New York', abbr: 'New York' },
    { name: 'North Carolina', abbr: 'North Carolina' },
    { name: 'North Dakota', abbr: 'North Dakota' },
    { name: 'Ohio', abbr: 'Ohio' },
    { name: 'Oklahoma', abbr: 'Oklahoma' },
    { name: 'Oregon', abbr: 'Oregon' },
    { name: 'Pennsylvania', abbr: 'Pennsylvania' },
    { name: 'Rhode Island', abbr: 'Rhode Island' },
    { name: 'South Carolina', abbr: 'South Carolina' },
    { name: 'South Dakota', abbr: 'South Dakota' },
    { name: 'Tennessee', abbr: 'Tennessee' },
    { name: 'Texas', abbr: 'Texas' },
    { name: 'Utah', abbr: 'Utah' },
    { name: 'Vermont', abbr: 'Vermont' },
    { name: 'Virginia', abbr: 'Virginia' },
    { name: 'Washington', abbr: 'Washington' },
    { name: 'West Virginia', abbr: 'West Virginia' },
    { name: 'Wisconsin', abbr: 'Wisconsin' },
    { name: 'Wyoming', abbr: 'Wyoming' }
];
const toggleStateDropdown = () => {
    setIsStateDropdownOpen(!isStateDropdownOpen);
};
const handleStateSelect = (abbr) => {
    // This calls your main handleChange logic
    handleChange({
        target: {
            name: 'state',
            value: abbr
        }
    });
    // Close the dropdown after selection
    setIsStateDropdownOpen(false);
};

const handleBranchStateSelect = (abbr) => {
    // This updates branchFormData
    setBranchFormData(prev => ({
        ...prev,
        state: abbr
    }));
    setBranchErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors.state;
        return newErrors;
    });
    // Close the dropdown after selection
    setIsStateDropdownOpen(false);
};
const validateFields = async() => {
     const newErrors = {};
    let isValid = true;

    if (!formData.organizationName) {
    newErrors.organizationName = "Organization name is required";
    isValid = false;
} else if (formData.organizationName.trim().length < 3) {
    newErrors.organizationName = "Organization name must be at least 3 characters long";
    isValid = false;
} else if (!/^[a-zA-Z0-9._\-\(\)\s]{3,50}$/.test(formData.organizationName)) {
    newErrors.organizationName =
        "Organization name can contain letters, numbers, periods, underscores, hyphens, parentheses, and spaces (3-50 characters).";
    isValid = false;
}



if (formData.domain) {
    const cleanedDomain = normalizeDomainInput(formData.domain);
    const domainPattern = /^[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,10}$/i;

    if (!cleanedDomain || !domainPattern.test(cleanedDomain)) {
        newErrors.domain =
            "Domain must be valid (e.g., whygrene.com, www.whygrene.com, https://whygrene.com) and end with a proper TLD like .com, .edu, .io.";
        isValid = false;
    }
}
    if (!formData.addressLine) {
      newErrors.addressLine = "Address line is required";
      isValid = false;
    }
    else if (formData.addressLine.length > 50) {
  newErrors.addressLine = "Address line must not exceed 50 characters";
  isValid = false;
}
    if (!formData.city) {
      newErrors.city = "City is required";
      isValid = false;
    }
    
    if (!formData.state) {
      newErrors.state = "State is required";
      isValid = false;
    }
    
    if (!formData.zipCode) {
      newErrors.zipCode = "Zip code is required";
      isValid = false;
    }
    else if (!/^\d{5}$/.test(formData.zipCode)) {
  newErrors.zipCode = "Zip code must be exactly 5 digits";
  isValid = false;
}
    if (!formData.firstName) {
      newErrors.firstName = "First name is required";
      isValid = false;
    }
    else if (!/^[a-zA-Z\s'-]{1,50}$/.test(formData.firstName)) {
  newErrors.firstName =
    "First name can only contain letters, spaces, hyphens, or apostrophes (max 50 characters).";
  isValid = false;
}
    if (!formData.lastName) {
      newErrors.lastName = "Last name is required";
      isValid = false;
    }
    else if (!/^[a-zA-Z\s'-]{1,50}$/.test(formData.lastName)) {
  newErrors.lastName =
    "Last name can only contain letters, spaces, hyphens, or apostrophes (max 50 characters).";
  isValid = false;
}
    if (!formData.email) {
      newErrors.email = "Email is required";
      isValid = false;
    }
    else if (
  !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(formData.email)
) {
  newErrors.email = "Invalid email format.";
  isValid = false;
} else if (formData.email.length > 256) {
  newErrors.email = "Email cannot exceed 256 characters.";
  isValid = false;
}
    if (!formData.phone) {
      newErrors.phone = "Phone number is required";
      isValid = false;
    }
    else if (!/^\d{10}$/.test(formData.phone)) {
        newErrors.phone = "US phone number must be 10 digits.";
        isValid = false;
      } {
  

}
  
if (!formData.password) {
  newErrors.password = "Password is required";
  isValid = false;
} else {

  const password = formData.password;

  const lower = /[a-z]/.test(password);
  const upper = /[A-Z]/.test(password);
  const digit = /\d/.test(password);
  const special = /[@$!%*?&]/.test(password);

  const complexityCount = [lower, upper, digit, special].filter(Boolean).length;

  if (password.length < 8 || complexityCount < 3) {
    newErrors.password =
      "Password must be at least 8 characters long and include at least 3 of the following: uppercase, lowercase, number, special character.";
    isValid = false;
  }
}

    if (!formData.confirmPassword) {
      newErrors.confirmPassword = "Confirm password is required";
      isValid = false;
    }
    if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  }


  const handleRegister = async (e) => {
    const isFormValid = await validateFields();
    e.preventDefault();
    if (!isFormValid) {
      return;
    }
    
    setError("");
    setLoading(true);
    
    try {
      const token = sessionStorage.getItem("accessToken");
      
      // Store org form data in sessionStorage for later use
      sessionStorage.setItem("orgFormData", JSON.stringify({
        organizationName: formData.organizationName,
        domain: formData.domain,
        addressLine: formData.addressLine,
        city: formData.city,
        state: formData.state,
        country: formData.country,
        zipCode: formData.zipCode,
        email: formData.email,
        firstName: formData.firstName,
        lastName: formData.lastName,
        phone: formData.phone,
        password: encryptPassword(formData.password),
      }));
      
      // Store org admin credentials for branch creation
      sessionStorage.setItem("orgAdminEmail", formData.email);
      sessionStorage.setItem("orgAdminPassword", encryptPassword(formData.password));
      sessionStorage.setItem("orgAdminFirstName", formData.firstName);
      sessionStorage.setItem("orgAdminLastName", formData.lastName);
      sessionStorage.setItem("orgAdminPhone", formData.phone);
      
      const normalizedDomainValue = formData.domain ? normalizeDomainInput(formData.domain) : "";
      
      // Call API to create organization and resource group
      const response = await fetch(
        `${PYTHON_API_BASE_URL}/signup/organization/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            "X-User-ID": sessionStorage.getItem("UserID") || "",
          },
          body: JSON.stringify({
            organization_name: formData.organizationName,
            domain_name: normalizedDomainValue,
            address_line: formData.addressLine,
            city: formData.city,
            state: formData.state,
            country: formData.country,
            zip_code: formData.zipCode,
            org_admin_email: formData.email,
            org_admin_first_name: formData.firstName,
            org_admin_last_name: formData.lastName,
            org_admin_phone: formData.phone,
            password: encryptPassword(formData.password),
            // Note: Not sending branch data here - only creating org and resource group
          }),
        }
      );

      let data;
      const responseText = await response.text();
      try {
        data = responseText ? JSON.parse(responseText) : {};
      } catch (parseError) {
        // If JSON parsing fails, use the raw text as error message
        throw new Error(responseText || `Failed with status: ${response.status}`);
      }
      
      if (!response.ok) {
        let errorMsg = "Failed to create organization";
        
        setErrors({});

        if (data) {
          const { fieldErrors, messages } = collectApiErrors(
            data,
            ORG_SIGNUP_FIELD_MAP
          );

          if (Object.keys(fieldErrors).length > 0) {
            setErrors(fieldErrors);
          }

          if (messages.length > 0) {
            errorMsg = messages.join(". ");
          } else if (Object.keys(fieldErrors).length > 0) {
            errorMsg = Object.values(fieldErrors).join(". ");
          } else if (data.error && typeof data.error === "object") {
            errorMsg = data.error.message || errorMsg;
          } else if (typeof data.error === "string") {
            errorMsg = data.error;
          }
        }
        
        // Handle specific error cases
        if (errorMsg.toLowerCase().includes("email") && errorMsg.toLowerCase().includes("already exists")) {
          errorMsg = "Email already exists. Please use a different email address.";
          setError(errorMsg);
          toast.error(errorMsg);
          setLoading(false);
          return;
        } else if (errorMsg.toLowerCase().includes("resource group") && errorMsg.toLowerCase().includes("already exists")) {
          // Check if organization was still created despite resource group error
          if (data.organization && data.organization.id) {
            // Organization was created, we can proceed
            
            toast.warning("Resource group already exists. Proceeding to branch creation.");
            // Store organization ID and proceed
            sessionStorage.setItem("organizationId", data.organization.id);
            sessionStorage.setItem("email", formData.email);
            let resourceGroupNameValue = "";
            if (data.resource_group_name) {
              resourceGroupNameValue = data.resource_group_name;
              sessionStorage.setItem("resourceGroupName", data.resource_group_name);
            } else if (data.resourceGroupName) {
              resourceGroupNameValue = data.resourceGroupName;
              sessionStorage.setItem("resourceGroupName", data.resourceGroupName);
            } else {
              const normalizedOrgName = formData.organizationName.replace(/\s+/g, "-");
              resourceGroupNameValue = `rg-${normalizedOrgName}-eastus`;
              sessionStorage.setItem("resourceGroupName", resourceGroupNameValue);
            }

            try {
              await createDefaultBranchAndNavigate(
                data.organization.id,
                resourceGroupNameValue,
                token,
                formData
              );
              toast.success("Organization and default branch created successfully");
              setLoading(false);
              return;
            } catch (branchErr) {
              const branchErrorMsg =
                branchErr.message || "Failed to create default branch. Please try again.";
              setError(branchErrorMsg);
              toast.error(branchErrorMsg, { duration: 6000 });
              setLoading(false);
              return;
            }
          } else {
            // Organization was not created, can't proceed
            errorMsg = "Resource group already exists and organization creation failed. Please try again.";
            setError(errorMsg);
            toast.error(errorMsg);
            setLoading(false);
            return;
          }
        } else if (errorMsg.toLowerCase().includes("organization") && errorMsg.toLowerCase().includes("already exists")) {
          errorMsg = "Organization already exists. Please use a different organization name.";
          setError(errorMsg);
          toast.error(errorMsg);
          setLoading(false);
          return;
        } else {
          // For other errors, show all error messages
          setError(errorMsg);
          toast.error(errorMsg);
          setLoading(false);
          return;
        }
      }

      
      
      const organizationId = data.organization && data.organization.id ? data.organization.id : null;
      if (organizationId) {
        sessionStorage.setItem("organizationId", organizationId);
      }
      
      let resourceGroupNameValue = "";
      if (data.resource_group_name) {
        resourceGroupNameValue = data.resource_group_name;
        sessionStorage.setItem("resourceGroupName", data.resource_group_name);
      } else if (data.resourceGroupName) {
        resourceGroupNameValue = data.resourceGroupName;
        sessionStorage.setItem("resourceGroupName", data.resourceGroupName);
      } else {
        const normalizedOrgName = formData.organizationName.replace(/\s+/g, "-");
        resourceGroupNameValue = `rg-${normalizedOrgName}-eastus`;
        sessionStorage.setItem("resourceGroupName", resourceGroupNameValue);
      }
      
      sessionStorage.setItem("email", formData.email);
      console.log("Organization data",formData);
      if (!organizationId) {
        throw new Error("Organization ID not returned. Cannot create default branch.");
      }
      
      try {
        await createDefaultBranchAndNavigate(
          organizationId,
          resourceGroupNameValue,
          token,
          formData
        );
       
        toast.success("Organization and default branch created successfully");
        return;
      } catch (branchError) {
        const errorMessage = branchError.message || "Failed to create default branch. Please try again.";
        setError(errorMessage);
        toast.error(errorMessage, { duration: 6000 });
        return;
      }
      
    } catch (err) {
      console.error("❌ Error creating organization:", err);
      let errorMsg = "Failed to create organization. Please try again.";
      
      // Try to extract full error message
      if (err.message) {
        errorMsg = err.message;
      } else if (typeof err === 'string') {
        errorMsg = err;
      }
      
      // If error message is too long, ensure it's displayed fully
      setError(errorMsg);
      toast.error(errorMsg, { duration: 5000 }); // Show toast for 5 seconds for longer messages
    } finally {
      setLoading(false);
    }
  };


  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }

    if (error) {
      setError("");
    }
  };

  const handleBranchChange = (e) => {
    const { name, value } = e.target;
    setBranchFormData({ ...branchFormData, [name]: value });
    setBranchErrors({ ...branchErrors, [name]: "" });
  };

  const validateBranchFields = () => {
    const newErrors = {};
    let isValid = true;

    
    if (!branchFormData.branchName) {
      newErrors.branchName = "Branch name is required";
      isValid = false;
    } 
    else if (!/^[A-Za-z0-9 ]+$/.test(branchFormData.branchName)) {
      newErrors.branchName = "Branch name can contain only letters, numbers, and spaces.";
      isValid = false;
    }
    

    if (!branchFormData.addressLine) {
      newErrors.addressLine = "Address line is required";
      isValid = false;
    } else if (branchFormData.addressLine.length > 50) {
      newErrors.addressLine = "Address line must not exceed 50 characters";
      isValid = false;
    }

    if (!branchFormData.city) {
      newErrors.city = "City is required";
      isValid = false;
    }

    if (!branchFormData.state) {
      newErrors.state = "State is required";
      isValid = false;
    }

    if (!branchFormData.zipCode) {
      newErrors.zipCode = "Zip code is required";
      isValid = false;
    }

    // Branch admin fields removed - using org admin credentials from sessionStorage

    setBranchErrors(newErrors);
    return isValid;
  };

  const handleRegisterBranch = async (e) => {
    e.preventDefault();
    
    if (!validateBranchFields()) {
      return;
    }

    setIsLoadingBranch(true);
    try {
      const token = sessionStorage.getItem("accessToken");
      
      // Get org form data from sessionStorage
      const orgFormDataStr = sessionStorage.getItem("orgFormData");
      if (!orgFormDataStr) {
        toast.error("Organization information not found. Please register organization first.");
        setIsLoadingBranch(false);
        return;
      }

      const orgFormData = JSON.parse(orgFormDataStr);
      const orgAdminEmail = orgFormData.email;
      const orgAdminPassword = orgFormData.password;
      const orgAdminFirstName = orgFormData.firstName;
      const orgAdminLastName = orgFormData.lastName;
      const orgAdminPhone = orgFormData.phone;
     
      // Get organization ID and resource group name from sessionStorage (created in previous step)
      const organizationId = sessionStorage.getItem("organizationId");
      const resourceGroupName = sessionStorage.getItem("resourceGroupName");
      
      if (!organizationId) {
        toast.error("Organization ID not found. Please complete organization registration first.");
        setIsLoadingBranch(false);
        return;
      }
      
      if (!resourceGroupName) {
        toast.error("Resource group name not found. Please complete organization registration first.");
        setIsLoadingBranch(false);
        return;
      }

      const payload = {
        branch_name: branchFormData.branchName,
        address_line: branchFormData.addressLine,
        city: branchFormData.city,
        state: branchFormData.state,
        country: branchFormData.country,
        zip_code: branchFormData.zipCode,
        branch_admin_first_name: orgAdminFirstName,
        branch_admin_last_name: orgAdminLastName,
        branch_admin_email: orgAdminEmail,
        branch_admin_phone: orgAdminPhone,
        password: orgAdminPassword,
        org_id: organizationId,
        resource_group_name: resourceGroupName,
      };

      const data = await createBranchRequest(payload, token);

      toast.success("Branch created successfully");
      
      if (data.id) {
        setSelectedBranch({ id: data.id, branch_name: data.branch_name, admin_email: data.admin_email, address: data.address });
      }
      sessionStorage.setItem("email", orgAdminEmail);

      setBranchErrors({});
      setBranchFormData({
        branchName: "",
        addressLine: "",
        city: "",
        state: "",
        country: "US",
        zipCode: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        password: "",
        confirmPassword: "",
      });
      
      // Navigate to login page
      navigate("/employeehomepage");
    } catch (err) {
      console.error("❌ Error in branch registration process:", err);
      let errorMsg = "Failed to complete registration. Please try again.";
      
      // Try to extract full error message
      if (err.message) {
        errorMsg = err.message;
      } else if (typeof err === 'string') {
        errorMsg = err;
      }
      
      // Handle UUID or ID related errors
      if (errorMsg.toLowerCase().includes("uuid") || 
          (errorMsg.toLowerCase().includes("invalid") && errorMsg.toLowerCase().includes("id"))) {
        errorMsg = `Invalid organization ID or resource group. ${errorMsg}. Please ensure you completed organization registration first.`;
      }
      
      // Ensure error message is displayed
      if (!errorMsg || errorMsg.trim() === "") {
        errorMsg = "An unexpected error occurred. Please check your organization registration and try again.";
      }
      
      console.error("❌ Displaying catch error to user:", errorMsg);
      setBranchErrors({ ...branchErrors, general: errorMsg });
      toast.error(errorMsg, { duration: 6000 }); // Show toast for 6 seconds for longer messages
    } finally {
      setIsLoadingBranch(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
  };

 
  
  

return (
  <>
  <div className="register-page">
    {/* Left side with background image */}
    <div className="register-image-section"></div>

    {/* Right side inputs - RENAMED TO register-form-section to match CSS */}
    <div 
      className={`register-form-section ${currentStep === "branch" ? "centered" : ""}`}
      style={currentStep === "branch" ? { 
        display: "flex", 
        alignItems: "center", 
        justifyContent: "center",
        height: "100vh"
      } : {}}
    > 
      {/* Container for the form elements - RENAMED TO register-form to match CSS */}
      <div className="register-form">
      
      {currentStep === "organization" ? (
        <> 
        <h2>New Organization Registration</h2>
        <p>Please fill out the required information to register the organization.</p>

        {/* --- Organization Information --- */}
        <h3>Organization Information</h3> 

        <div className="form-group-register">
         <label>Organization Name<span className="required-asterisk">*</span></label>
           <input
            type="text"
            name="organizationName"
            className="wide-input"
            placeholder="Ex. WhyGrene Motors"
            value={formData.organizationName}
            onChange={handleChange}
            
          />
            {errors.organizationName && (
              <span className="register-error-message">
                {errors.organizationName}
              </span>
            )}
        </div>

        <div className="form-group-register">
          
           {/* <label>Domain <span className="required-asterisk">*</span></label> */}
           <label>Domain</label>
           <input
            type="text"
            name="domain"
            className="wide-input"
            placeholder="Ex. website.com"
            value={formData.domain}
            onChange={handleChange}
            
          />
            {errors.domain && (
              <span className="register-error-message">
                {errors.domain}
              </span>
            )}
            </div>

        <div className="form-group-register">
          <label>Address Line <span className="required-asterisk">*</span></label>
           <input
            type="text"
            name="addressLine"
            className="wide-input"
            placeholder="Enter Address Line 1"
            value={formData.addressLine}
            onChange={handleChange}
            
          />
            {errors.addressLine && (
              <span className="register-error-message">
                {errors.addressLine}
              </span>
            )}
</div>


 
        {/* CITY and STATE (Two-column row) - RENAMED CLASS */}
      <div className="register-form-row"> 
          <div className="form-group-register">
            <label>City <span className="required-asterisk">*</span></label>
           

            <input
            type="text"
            name="city"
            className="wide-input"
            placeholder="Enter City"
            value={formData.city}
            onChange={handleChange}
            
          />
            {errors.city && (
              <span className="register-error-message">
                {errors.city}
              </span>
            )}
          </div>

      
<div className="form-group-register">
  <label>State <span className="required-asterisk">*</span></label>
  
  <div className="custom-select-wrapper-state">
      
      {/* ➡️ MODIFIED: Added a wrapper div for the content and icon */}
      <div 
          className="custom-select-display" 
          onClick={toggleStateDropdown}
      >
          {/* Content (State Name) */}
          <span className="select-display-text">
            {usStates.find(s => s.abbr === formData.state)?.name || "--Select a State--"}
          </span>
          
          {/* ➡️ ICON PLACEMENT: Use the new icon and apply a class for styling */}
          <FaChevronDown 
              className={`select-caret-icon ${isStateDropdownOpen ? 'rotated' : ''}`}
          />
      </div>

      
    {isStateDropdownOpen && (
          <ul className="custom-options-list-state">
              
              <li className="disabled-option">
          --Select a State--
      </li>
              {usStates.map(state => (
                  <li 
                      key={state.abbr} 
                      onClick={() => handleStateSelect(state.abbr)}
                      className={formData.state === state.abbr ? 'selected' : ''}
                  >
                      {state.name}
                  </li>
              ))}
          </ul>
      )}
  </div>
  {errors.state && (
    <span className="register-error-message">
      {errors.state}
    </span>
  )}
  
  {/* ... error message ... */}
</div>
        </div>

        {/* COUNTRY and ZIP CODE (Two-column row) - RENAMED CLASS */}
        <div className="register-form-row"> 
          <div className="form-group-register">
            <label>Country <span className="required-asterisk">*</span></label>
            
             <select 
              name="country"
              value={formData.country}
              onChange={handleChange}
              
            >
            
              <option value="US">United States</option>
            </select>
            {errors.country && (
              <span className="register-error-message">
                {errors.country}
              </span>
            )}
          </div>
          <div className="form-group-register">
            <label>Zip Code <span className="required-asterisk">*</span></label>
             <input
              type="text"
              name="zipCode"
              placeholder="Zipcode"
              value={formData.zipCode}
              onChange={handleChange}
              
             />
            {errors.zipCode && (
              <span className="register-error-message">
                {errors.zipCode}
              </span>
            )}
          </div>
        </div>

        {/* --- Organization Admin Information --- */}
        <h3>Organization Admin Information</h3>

        {/* FIRST NAME and LAST NAME (Two-column row) - RENAMED CLASS */}
        <div className="register-form-row"> 
          <div className="form-group-register">
            <label>First Name <span className="required-asterisk">*</span></label>
             <input
              type="text"
              name="firstName"
              placeholder="Ex. John"
              value={formData.firstName}
              onChange={handleChange}
              
            />
            {errors.firstName && (
              <span className="register-error-message">
                {errors.firstName}
              </span>
            )}
          </div>

          <div className="form-group-register">
            <label>Last Name <span className="required-asterisk">*</span></label>
             <input
              type="text"
              name="lastName"
              className="wide-input"
              placeholder="Ex. Doe"
              value={formData.lastName}
              onChange={handleChange}
              
            />
            {errors.lastName && (
              <span className="register-error-message">
                {errors.lastName}
              </span>
            )}
          </div>
        </div>

        {/* EMAIL and PHONE (Two-column row) - RENAMED CLASS */}
        <div className="register-form-row"> 
          <div className="form-group-register">
             <label>Email <span className="required-asterisk">*</span></label>
             <input
              type="email"
              name="email"
              className="wide-input"
              placeholder="Ex. john@whygrene.com"
              value={formData.email}
              onChange={handleChange}
              
             />

            {errors.email && (
              <span className="register-error-message">
                {errors.email}
              </span>
            )}
          </div>

          <div className="form-group-register">
            <label>Phone <span className="required-asterisk">*</span></label>
            {/* Phone Country Code and Input Wrapper */}
            <div   className="combined-phone-input-container"> 
              <select name="country" value={formData.country} onChange={handleChange} 
                          className="phone-country-select" required>
                <option value="US">US</option>
                
              </select>
              <input
                type="text"
                name="phone"
                placeholder={"Ex: 231 221 1299"}
                className="phone-number-input"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>
            {errors.phone && (
              <span className="register-error-message">
                {errors.phone}
              </span>
            )}
          </div>
        </div>

        {/* PASSWORD and CONFIRM PASSWORD (Two-column row) - RENAMED CLASS */}
        <div className="register-form-row"> 
          <div className="form-group-register">
            <label>Password <span className="required-asterisk">*</span></label>
             <div className="input-with-icon">
           

            <input
               type={showPassword ? "text" : "password"}
              name="password"
              className="wide-input"
              value={formData.password}
              onChange={handleChange}
              
            />
            <span className="icon" onClick={() => setShowPassword(!showPassword)}>
                                  <FaEye className={showPassword ? "icon-visible" : "icon-hidden"} />
                                  <FaEyeSlash className={showPassword ? "icon-hidden" : "icon-visible"} />
                                </span>
                                </div>
            {errors.password && (
              <span className="register-error-message">
                {errors.password}
              </span>
            )}
          </div>

          <div className="form-group-register">
            <label>Confirm Password <span className="required-asterisk">*</span></label>
             <div className="input-with-icon">
          

            <input
              type={showConfirmPassword ? "text" : "password"}
              name="confirmPassword"
              className="wide-input"
              value={formData.confirmPassword}
              onChange={handleChange}
              
             />
             <span className="icon" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                  <FaEye className={showConfirmPassword ? "icon-visible" : "icon-hidden"} />
                                  <FaEyeSlash className={showConfirmPassword ? "icon-hidden" : "icon-visible"} />
                                </span>
                                </div>
            {errors.confirmPassword && (
              <span className="register-error-message">
                {errors.confirmPassword}
              </span>
            )}
          
          </div>
         </div>

        
        {error && (
  <div className="error-message-box">
    {error}
  </div>
)}

        <button type="submit" 
        className="register-button" 
        onClick={handleRegister}
        disabled={loading}>
          {loading ? (
            <>
              <span className="spinner" style={{ marginRight: '8px', display: 'inline-block' }}></span>
              Creating Organization...
            </>
          ) : (
            "Next"
          )}
        </button>
        <div className="account-register">
      <Link to="/employeehomepage" className="account-register-signup-link">
                    Back to Login
                  </Link>
                  </div>
        </>
      ) : (
        <form className="register-form branch-form-centered" onSubmit={handleRegisterBranch}>
          <h2>New Branch Registration</h2>
          <p style={{ color: "#4A5568" }}>Please fill out the required information to register the branch</p>

          <h3>Branch Information</h3>
          <div className="form-group-register">
            <label>Branch Name<span className="required-asterisk">*</span></label>
            <input
              type="text"
              name="branchName"
              className="wide-input"
              placeholder="Ex. whygrene"
              value={branchFormData.branchName}
              onChange={handleBranchChange}
            />
            {branchErrors.branchName && (
              <span className="register-error-message">{branchErrors.branchName}</span>
            )}
          </div>

          <div className="form-group-register">
            <label>Address Line <span className="required-asterisk">*</span></label>
            <input
              type="text"
              name="addressLine"
              className="wide-input"
              placeholder="Address Line 1"
              value={branchFormData.addressLine}
              onChange={handleBranchChange}
            />
            {branchErrors.addressLine && (
              <span className="register-error-message">{branchErrors.addressLine}</span>
            )}
          </div>
          
          <div className="register-form-row"> 
          <div className="form-group-register">
            <label>City <span className="required-asterisk">*</span></label>
          

            <input
            type="text"
            name="city"
            className="wide-input"
            placeholder="Enter City"
            value={branchFormData.city}
            onChange={handleChange}
            
          />
            {errors.city && (
              <span className="register-error-message">
                {errors.city}
              </span>
            )}
          </div>

          <div className="form-group-register">
  <label>State <span className="required-asterisk">*</span></label>
  
  <div className="custom-select-wrapper-state">
      
      {/* ➡️ MODIFIED: Added a wrapper div for the content and icon */}
      <div 
          className="custom-select-display" 
          onClick={toggleStateDropdown}
      >
          {/* Content (State Name) */}
          <span className="select-display-text">
            {usStates.find(s => s.abbr === branchFormData.state)?.name || "--Select a State--"}
          </span>
          
          {/* ➡️ ICON PLACEMENT: Use the new icon and apply a class for styling */}
          <FaChevronDown 
              className={`select-caret-icon ${isStateDropdownOpen ? 'rotated' : ''}`}
          />
      </div>

      
    {isStateDropdownOpen && (
          <ul className="custom-options-list-state">
              
              <li className="disabled-option">
          --Select a State--
      </li>
              {usStates.map(state => (
                  <li 
                      key={state.abbr} 
                      onClick={() => handleStateSelect(state.abbr)}
                      className={branchFormData.state === state.abbr ? 'selected' : ''}
                  >
                      {state.name}
                  </li>
              ))}
          </ul>
      )}
  </div>
  {errors.state && (
    <span className="register-error-message">
      {errors.state}
    </span>
  )}
  
  {/* ... error message ... */}
</div>
        </div>
        
        <div className="register-form-row"> 
                <div className="form-group-register">
                  <label>Country <span className="required-asterisk">*</span></label>
                  <select id="country" value={branchFormData.country} onChange={handleBranchChange} name="country">
                    {/* <option value="">----Select a Country----</option> */}
                    <option value="US">United States</option>
                  </select>
                  {branchErrors.country && <span className="register-error-message">{branchErrors.country}</span>}
                </div>
          <div className="form-group-register">
            <label>Zip Code <span className="required-asterisk">*</span></label>
            <input
              type="text"
              name="zipCode"
              className="wide-input"
              placeholder="Enter Zip Code"
              value={branchFormData.zipCode}
              onChange={handleBranchChange}
            />
            {branchErrors.zipCode && (
              <span className="register-error-message">{branchErrors.zipCode}</span>
            )}
          </div>
          </div>

          {/* Branch Admin Information section removed - using org admin credentials from sessionStorage */}


          {branchErrors.general && (
            <div className="error-message-box">{branchErrors.general}</div>
          )}

          <button
            type="submit"
            className="register-button"
            disabled={isLoadingBranch}
          >
            {isLoadingBranch ? "Creating..." : "Register"}
            {isLoadingBranch && <span className="spinner"></span>}
          </button>
          <div className="account-register">
            <Link
              to="/employeehomepage"
              className="account-register-signup-link"
            >
              Back to Login
            </Link>
          </div>
        </form>
      )}
      </div>
    </div>
  </div>
  </>
);

}
